export const WHOLESALE = 'WHOLESALE';
export const RETAIL = 'RETAIL';

const SalesType = [
  {
    label: 'Retail',
    value: RETAIL,
  },
  {
    label: 'Wholesale',
    value: WHOLESALE,
  },
];

export default SalesType;
